export default "__VITE_ASSET__BcruwDHe__"